// Angular
import { NgModule } from "@angular/core";

// Afidium
import { CommonModule } from "@angular/common";
import { BtnModule } from "libraries/ui_button/btn.module";
import { ConfirmDialogComponent } from "./confirm-dialog.component";
import { CardModule } from "libraries/ui_card/card.module";
import { LoaderModule } from "libraries/component/loader/loader.module";
import {SafeHtmlPipeModule} from "../../../pipes/safeHtml/safeHtml.module";

@NgModule({
    imports: [
        CommonModule,
        BtnModule,
        CardModule,
        LoaderModule,
        SafeHtmlPipeModule,
    ],
    declarations: [
        ConfirmDialogComponent,
    ],
    exports: [
        ConfirmDialogComponent,
    ],
    entryComponents: [
        ConfirmDialogComponent,
    ]
})
export class ConfirmDialogModule {}